import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: '0 3px 11px rgb(0 0 0 / 16%)',
  },
  media: {
    height: 160,
    position: 'relative',
    '&:hover': {
      zIndex: '1'
    },
  },
  overlay: {
    content: '',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    width: '100%',
    height: '100%',
    backgroundColor: '#000',
    zIndex: '0',
    display: 'block',
    opacity: '0.3',
    borderRadius: '50px',
    '&:hover': {
      opacity: '0.1',
      zIndex: '0',
      '- webkitTransition': 'opacity 0.5s ease-in -out',
      '- mozTransition': 'opacity 0.5s ease -in -out',
      'transition': 'opacity 0.5s ease -in -out',
    },
  },
}))




